export default "__VITE_PUBLIC_ASSET__f7865ed3__"